module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step2-1efe558e9bae7760b71764050d5053b8.jpg";